<template>
    <div class="personalities-edit" v-if="can_edit_personality">
      <v-container class="ma-0 pa-0 mt-10" fluid>
        <v-row v-if="personality_permission">
            <v-col cols =6>
                <v-switch
                    v-model="show_personality"
                    color="#0635AC"
                    label="Показывать персоналию на сайте">
                </v-switch>
            </v-col>
            <v-col cols =6>
                <v-switch
                    v-model="allow_comments"
                    color="#0635AC"
                    label="Позволять комментировать">
                </v-switch>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols =12>
                {{ change_user_msg }}
            </v-col>
            <v-col cols =12>
                <v-btn
                    @click="updateUser">
                    Обновить данные
                </v-btn>
            </v-col>
        </v-row>
      </v-container>
    </div>
</template>
<script>

import { useUserStore } from '@/store/user';
import { useAuthStore } from '@/store/auth';

export default{
    name: 'PersonalitiesSettings',
    mounted(){
        let UserStore = useUserStore()
        UserStore.changeUserMsg = ''
    },
    computed:{
        show_personality: {
            get(){
                const userStore = useUserStore()
                if (userStore.changeUser.show_personality)
                    return userStore.changeUser.show_personality 
                return false
            },
            set(newValue){
                const userStore = useUserStore()
                userStore.changeUser.show_personality = newValue 
            }
        },
        allow_comments: {
            get(){
                const userStore = useUserStore()
                if (userStore.changeUser.allow_comments)
                    return userStore.changeUser.allow_comments 
                return false
            },
            set(newValue){
                const userStore = useUserStore()
                userStore.changeUser.allow_comments = newValue 
            }
        },
        can_edit_personality() {
            let AuthStore = useAuthStore()
            return AuthStore.can_edit_personality
        },
        personality_permission(){
            let AuthStore = useAuthStore()
            return AuthStore.personality_permission
        },
        change_user_msg(){
            let UserStore = useUserStore()
            return UserStore.changeUserMsg
        }
    },
    methods:{
        async updateUser(){
            let UserStore = useUserStore()
            await UserStore.updateUser()
        }
    },
}
</script>